import {
  registerApplication,
  RegisterApplicationConfig,
  start
} from 'single-spa';
import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes
} from 'single-spa-layout';
import layout from './single-spa-layout.html';
import { initTheme } from './utils/theme';
import './assets/index.css';
import { initEventBus } from './utils/event-bus';
import { checkAuth } from './utils/auth';
import { tokenStore, userStore, sidebarStore } from './store';
import { isRouteAnonymous } from './utils/is-route-anonymous';
import { isLoggerEnabled } from './utils/is-logger-enabled';

const rootEventBus = initEventBus();

// Single-spa setup
const routes = constructRoutes(layout, {
  loaders: {
    content: `<div class="app-loader"></div>`
  },
  props: {}
});

const loaders = {
  '@portal/profile': () => System.import('@portal/profile'),
  '@portal/faq': () => System.import('@portal/faq')
};

const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  }
});

const allAppsRegistration = async () => {
  const { getToken } = tokenStore();
  const { getUser } = userStore();

  const loginData = getToken();
  const userData = getUser();

  const permissionsModule = await System.import('@config/permissions');

  applications.forEach((app: RegisterApplicationConfig) => {
    loaders[app.name] = () => System.import(app.name);
  });

  applications.forEach((app: RegisterApplicationConfig) => {
    const registrationConfig = {
      ...app,
      customProps: {
        applications: loaders,
        rootEventBus,
        loginData,
        userData,
        isOpenSidebar: sidebarStore.isOpen.value,
        sidebarStore: sidebarStore,
        permissionsConfig: permissionsModule.default
      }
    };

    if (app.name === '@portal/core') {
      registrationConfig.activeWhen = () =>
        !isRouteAnonymous(location.pathname);
    }

    if (app.name !== '@portal/profile' && app.name !== '@portal/faq') {
      // These 2 are invoked manually
      registerApplication(registrationConfig);
    }
  });
};

allAppsRegistration();

constructLayoutEngine({ routes, applications }).activate();

start({
  urlRerouteOnly: true
});

initTheme();

checkAuth();

if (isLoggerEnabled()) {
  // eslint-disable-next-line no-console
  console.log(
    `%cAPP:[ROOT_PORTAL]`,
    'color: #fff; background-color: #0A0; font-weight: bold;',
    __BUILD_TIME__,
    __BUILD_NAME__
  );
}
